<template>
  <div class="p-4 chart-leak-size-tb">
    <h4>{{ chartRoute.title }}</h4>
    <p>The Pandora Papers dataset is bigger than any previous leak investigated by ICIJ, when measured in terabytes.</p>
    <stacked-column-chart
      :data="$options.tsv"
      :social-mode="socialMode"
      :social-mode-ratio="0.75"
      :fixed-height="fixedHeight"
      label-field="label"
      hide-legend
      no-tooltips
      bar-max-width="50%"
      :y-axis-tick-format="value => `${value}TB`"/>
    <p class="text-muted mt-2 small text-right">Source: ICIJ</p>
  </div>
</template>

<script>
import chart from '../mixins/chart'

export default {
  mixins: [chart],
  name: 'ChartLeakSizeTb'
}
</script>

<style lang="scss" scoped>
.chart-leak-size-tb /deep/ .stacked-column-chart {

  &__groups__item {

    &:nth-child(1) .stacked-column-chart__groups__item__bars__item,
    &:nth-child(2) .stacked-column-chart__groups__item__bars__item {
      background: var(--group-color-3n);

      .chart--social-mode & {
        background: #433;
      }
    }
  }
}
</style>

<tsv>
label	value
Panama Papers (2016)	2.6
Paradise Papers (2017)	1.4
Pandora Papers (2021)	2.94
</tsv>
